import React from 'react';
import { Grid, Button } from '@mui/material';
import { Save as SaveIcon, Cancel as CancelIcon } from '@mui/icons-material';

interface ProfileActionsProps {
    isEditing: boolean;
    onSave: () => void;
    onCancel: () => void;
}

const ProfileActions: React.FC<ProfileActionsProps> = ({ isEditing, onSave, onCancel }) => {
    if (!isEditing) return null;

    return (
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
            <Button
                variant="outlined"
                startIcon={<CancelIcon />}
                onClick={onCancel}
                color="error"
            >
                Cancel
            </Button>
            <Button
                variant="contained"
                startIcon={<SaveIcon />}
                onClick={onSave}
                color="primary"
            >
                Save Changes
            </Button>
        </Grid>
    );
};

export default ProfileActions;
